<!-- <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>
        <mat-icon (click)="stayActive()">close</mat-icon>
    </button>
</mat-dialog-actions> -->

<h2 mat-dialog-title>{{data.dialogTitle}}</h2>
<mat-dialog-content>
    <p>{{data.dialogText}}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-flat-button class="btn btn-success" (click)="stayActive()">{{data.buttonText}}</button>
</mat-dialog-actions>